import { render, staticRenderFns } from "./DomainChangeOwner.vue?vue&type=template&id=22f22ca8&"
import script from "./DomainChangeOwner.vue?vue&type=script&lang=js&"
export * from "./DomainChangeOwner.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports